<mat-card appearance="raised">
  <mat-card-content>
    <div class="w-full flex flex-col flex-wrap justify-start items-start gap-4">
      <div class="w-full flex flex-row items-center gap-4">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Select Date</mat-label>
          <input matInput [matDatepicker]="picker" [formControl]="dateInput" />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Search</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [formControl]="searchControl" placeholder="Search by project, task, customer or notes...">
          @if (searchControl.value) {
            <mat-icon matSuffix class="cursor-pointer" (click)="searchControl.setValue('')">close</mat-icon>
          }
        </mat-form-field>

        <p class="whitespace-nowrap">Total Hours: {{ _zohoBooksFeature.totalHoursAccumulated | number: "1.0-2" }}</p>
      </div>
      <div class="w-full flex flex-row flex-wrap justify-between items-center gap-4">
        <mat-button-toggle-group [formControl]="groupByDateTypeInput" name="groupBySelection" aria-label="Group selection">
          <mat-button-toggle value="day">Day</mat-button-toggle>
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>

        <button mat-raised-button (click)="resetFilters()">Reset All Filters</button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
